function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.643 20.25H46.929A6.448 6.448 0 0 0 40.5 26.7v67.1a6.448 6.448 0 0 0 6.429 6.452h43.714a6.448 6.448 0 0 0 6.428-6.452V26.7a6.448 6.448 0 0 0-6.428-6.45zm-21.857 3.871a2.581 2.581 0 1 1-2.572 2.579 2.576 2.576 0 0 1 2.572-2.579zm23.143 64.516a1.288 1.288 0 0 1-1.286 1.29H46.929a1.288 1.288 0 0 1-1.286-1.29V34.444a1.288 1.288 0 0 1 1.286-1.29h43.714a1.288 1.288 0 0 1 1.286 1.29z",
  transform: "rotate(-90 28.286 28.285) translate(-40.5 -20.25)"
}));

function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 56.571,
    viewBox: "0 0 80 56.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.d0388602.svg";
export { ForwardRef as ReactComponent };